import Settings from './Settings.vue';
import MenuItem from './MenuItem.vue';

const routes = [
  {
    name: 'modules.fallback_package',
    component: Settings,
    path: '/modules/fallback_package',
  },
];

export default {
  menu_item: MenuItem,
  settings_component: Settings,
  routes,
};
